import { updateAdmitPatientApi } from "@/utils/apis/doctor/ipDashboard";

import { INotifyEnum, notify } from "@/utils/toaster";

import {
  fetchDoctorHospitalPatientListing,
  ipDashboardDetails,
  resetAdmitPatientDetail,
} from "@/store/slices/doctor/ipDashboard";
import { useAppDispatch, useAppSelector } from "@/store/hooks";

import { getTodayTomorrowDate } from "@/utils";

import { IUpdateAdmitPatientRequest } from "@/models/ApiRequestResponse/doctor";
import { IPDashboardPatientAdmitStatus } from "@/models/doctor";

const useUpdateAdmitPatient = () => {
  const dispatch = useAppDispatch();
  const { selectedHospitalId, selectRoomId } =
    useAppSelector(ipDashboardDetails);

  const updateAdmitPatientHandler = async (
    requedBody: IUpdateAdmitPatientRequest
  ) => {
    const reAdmitPatientResponse = await updateAdmitPatientApi(requedBody);
    if ("result" in reAdmitPatientResponse) {
      notify(INotifyEnum.SUCCESS, reAdmitPatientResponse.message);
      const { today } = getTodayTomorrowDate();
      dispatch(
        fetchDoctorHospitalPatientListing({
          hospitalId: selectedHospitalId,
          end_date: today,
          ...(selectRoomId !== "1" && { room_id: selectRoomId }),
        })
      );
      if (requedBody.status === IPDashboardPatientAdmitStatus.DISCHARGED) {
        dispatch(resetAdmitPatientDetail());
      }
      return;
    }
    notify(INotifyEnum.ERROR, reAdmitPatientResponse.message);
  };
  return { updateAdmitPatientHandler };
};

export default useUpdateAdmitPatient;
